import { gql } from "@apollo/client";
import Fragments from "./fragments";

export const PARTNER_TYPES_QUERY = gql`
  query partnerTypes {
    partnerTypes {
      id
      code
      name
    }
  }
`;

export const USAGE_TYPES_QUERY = gql`
  query usageTypes {
    usageTypes {
      id
      code
      name
    }
  }
`;

export const COUNTIES_QUERY = gql`
  query counties {
    counties {
      id
      name
    }
  }
`;

export const CITIES_QUERY = gql`
  query cities($countyId: Int!) {
    cities(countyId: $countyId) {
      id
      name
    }
  }
`;

export const NATIONALITIES_QUERY = gql`
  query nationalities {
    nationalities {
      id
      code
      name
    }
  }
`;

export const PERSON_DOCUMENT_TYPES_QUERY = gql`
  query personDocumentTypes {
    personDocumentTypes {
      id
      code
      name
    }
  }
`;

export const MASTER_PARTNER_QUERY = gql`
  query masterPartner($uniqueId: String!, $partnerTypeId: Int!) {
    masterPartner(uniqueId: $uniqueId, partnerTypeId: $partnerTypeId) {
      partnerId
      partnerTypeId
      uniqueID
      partnerCode
      partnerName
      firstName
      lastName
      contactPersonName
      contactPersonUniqueID
      chContactPersonId
      identityCardNo
      identityDocumentTypeId
      issuedBy
      startDate
      endDate
      citizenshipId
      nationalityId
      email
      phoneNumber
      phoneCountryCode
      countyId
      countyName
      city {
        id
        name
      }
      street
      streetNumber
      buildingNumber
      stairNumber
      floorNumber
      flatNumber
      zipCode
      activityFieldId
      activityFieldName
      usageTypeCode
      drivingLicenseReleaseDate
      validationMoment
      chPartnerId
      chPersonId
    }
  }
`;

export const PARTNER_QUERY = gql`
  query partner($partnerId: Int!) {
    partner(partnerId: $partnerId) {
      ...partnerData
    }
  }
  ${Fragments.partnerData}
`;

export const LEGAL_PARTNERS_QUERY = gql`
  query legalPartners($page: Int, $pageSize: Int, $uniqueId: String, $name: String, $partnerTypeId: Int) {
    legalPartners(page: $page, pageSize: $pageSize, uniqueId: $uniqueId, name: $name, partnerTypeId: $partnerTypeId) {
      ...legalPartner
    }
  }
  ${Fragments.legalPartner}
`;

export const INDIVIDUAL_PARTNERS_QUERY = gql`
  query individualPartners(
    $page: Int
    $pageSize: Int
    $fullName: String
    $citizenshipId: Int
    $birthDate: String
    $countyId: Int
    $cityId: Int
    $idSeriesAndNumber: String
  ) {
    individualPartners(
      page: $page
      pageSize: $pageSize
      fullName: $fullName
      citizenshipId: $citizenshipId
      birthDate: $birthDate
      countyId: $countyId
      cityId: $cityId
      idSeriesAndNumber: $idSeriesAndNumber
    ) {
      ...individualPartner
    }
  }
  ${Fragments.individualPartner}
`;

export const SYSTEM_PARTNERS_QUERY = gql`
  query systemPartners {
    systemPartners {
      ...partnerData
    }
  }
  ${Fragments.partnerData}
`;
